import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';
import { generateReqBodyWithFiles } from '../utils/generateReqBodyWithFiles';

const baseURL = 'newDoc';

const documentService = {
  getDocuments: (data, docTypeId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/documents/${encodeURIComponent(docTypeId)}`,
      data,
    });
  },

  getDocumentById: (id, docTypeId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}/${encodeURIComponent(docTypeId)}`,
    });
  },

  createDocument: (data, files) => {
    const formData = generateReqBodyWithFiles(data, files);

    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data: formData,
    });
  },

  updateDocument: (data, id, files) => {
    const formData = generateReqBodyWithFiles(data, files);

    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
    });
  },

  deleteDocument: (data, id, docTypeId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}/${encodeURIComponent(docTypeId)}`,
      data,
    });
  },

  printDocument: async (data) => {
    const pdf = await request({
      responseType: 'blob',
      method: Methods.POST,
      resource: `${baseURL}/print`,
      data,
    });

    return downloadFile(pdf, pdf.filename);
  },

  checkReferenced: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkReferenced`,
      data,
    });
  },

  getItemStock: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getItemStock`,
      data,
    });
  },

  upsertSettlement: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/settlement`,
      data,
    });
  },

  autoCreateSettlement: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/settlement/autoCreate`,
      data,
    });
  },

  deleteSettlement: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/settlement/${encodeURIComponent(id)}`,
    });
  },

  getContactMap: (docTypeId, docId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/contactMap/${encodeURIComponent(docTypeId)}/${encodeURIComponent(docId)}`,
    });
  },

  hasTargetDownPaymentRequest: (docId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/target/downPaymentRequest/${encodeURIComponent(docId)}`,
    });
  },

  getDownPayments: (companyId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/lines/downPayments/${encodeURIComponent(companyId)}`,
    });
  },

  docStorno: (docId, docTypeId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(docId)}/${encodeURIComponent(docTypeId)}/storno`,
      data,
    });
  },
  getDocLinesByTypeAndCompany: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getDocLinesByTypeAndCompany`,
      data,
    });
  },

  getPrevPrices: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/prevPrices`,
      data,
    });
  },
};

export default documentService;
